/* eslint-disable */

import React, { Component } from 'react';
import gql from 'graphql-tag';
import update from 'react-addons-update';
import { bindActionCreators } from 'redux';
import { compose, graphql, withApollo } from 'react-apollo';
import { Loader } from 'semantic-ui-react';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as AppActions from '../../actions';

import './CanvasSearch.css';

import CanvasBuilder from './CanvasBuilder';
import CanvasList from './CanvasList';
import { getCanvasData, launchCanvasToFacebook } from './CanvasLauncher';

import { toast } from 'react-toastify';

class CanvasSearch extends Component {
  state = {
    section: 'search',
    message: '',
    errorDetails: [],
    processing: false
  };

  componentDidMount() {
    this.props.setSectionTitle('Canvas Tool');
    this.props.saveGTMEvent('Canvas Tool', 'Canvas Tool');
  }

  componentWillReceiveProps = () => {
    this.props.data.refetch();
  };

  refresh = () => {
    this.props.data.refetch();
  };

  newCanvas = () => {
    this.setState({
      section: 'newCanvas',
      message: '',
      errorDetails: [],
      canvasToEdit: null
    });
  };

  launchCanvas = async (parameters) => {
    if (!parameters.pageId) {
      this.setState({ message: 'You must select a page to launch a canvas' });
      return;
    }

    const canvas = getCanvasData(parameters.canvasId, this.props.data);
    this.setState({
      processing: true,
      errorDetails: [],
      message: `Launching ${canvas[0].name}`
    });
    // eslint-disable-next-line no-param-reassign
    parameters.is_published = false;

    let errorDetails = [];
    try {
      const result = await launchCanvasToFacebook(parameters, canvas);
      errorDetails = result.errorDetails;

      if (!result.result) {
        this.setState({
          processing: false,
          message: `There was an error launching ${canvas[0].name}`,
          errorDetails
        });
      } else {
        this.setState({
          processing: false,
          message: `${canvas[0].name} has been launched`
        });
      }

      setTimeout(() => {
        this.setState({ message: '', errorDetails: [] });
      }, 5000);
    } catch (error) {
      this.setState({
        processing: false,
        message: `There was an error launching ${canvas[0].name}`
      });
      setTimeout(() => {
        this.setState({ message: '', errorDetails: [] });
      }, 5000);
    }
  };

  launchCanvasWithToast = async (parameters) => {
    if (!parameters.pageId) {
      this.setState({ message: 'You must select a page to launch a canvas' });
      return;
    }

    const canvas = getCanvasData(parameters.canvasId, this.props.data);
    parameters.is_published = false;

    let errorDetails = [];
    try {
      const result = await launchCanvasToFacebook(parameters, canvas);
      errorDetails = result.errorDetails;

      if (!result.result) {
        toast(`There was an error launching ${canvas[0].name}`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 4000,
          type: toast.TYPE.WARNING,
          hideProgressBar: true
        });
      } else {
        toast(`${canvas[0].name} has been launched`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 4000,
          type: toast.TYPE.SUCCESS,
          hideProgressBar: true
        });
      }
    } catch (error) {
      toast(`There was an error launching ${canvas[0].name} ${error}`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 4000,
        type: toast.TYPE.WARNING,
        hideProgressBar: true
      });
    }
  };

  saveToEdit = async (id) => {
    await this.props.data.refetch();
    await this.editCanvas(id);
  };

  editCanvas = (id) => {
    const canvas = getCanvasData(id, this.props.data);
    canvas.canvasElements = _.sortBy([...canvas.canvasElements], 'order');
    this.setState({
      section: 'newCanvas',
      message: '',
      errorDetails: [],
      canvasToEdit: canvas
    });

    return canvas;
  };

  deleteCanvas = async (id) => {
    await this.deletePhotos(id);
    await this.deleteVideos(id);
    await this.deleteCarousels(id);
    await this.deleteCanvasTiles(id);
    await this.props.deleteCanvas(id);
  };

  deletePhotos = async (id) => {
    const canvasPhotos = this.props.data.canvasPhoto.list.filter((photo) => {
      return photo.canvasId === id;
    });

    await Promise.all(
      canvasPhotos.map(async (photo) => {
        await this.props.deleteCanvasPhoto(photo.id);
        return Promise.resolve(photo.id);
      })
    );
  };

  deleteCanvasTiles = async (id) => {
    const canvasTiles = this.props.data.canvasTile.list.filter((tile) => {
      return tile.canvasId === id;
    });

    await Promise.all(
      canvasTiles.map(async (tile) => {
        await this.props.deleteCanvasTile(tile.id);
        return Promise.resolve(tile.id);
      })
    );
  };

  deleteVideos = async (id) => {
    const canvasVideos = this.props.data.canvasVideo.list.filter((video) => {
      return video.canvasId === id;
    });

    await Promise.all(
      canvasVideos.map(async (video) => {
        await this.props.deleteCanvasVideo(video.id);
        return Promise.resolve(video.id);
      })
    );
  };

  deleteCarousels = async (id) => {
    const canvasCarousels = this.props.data.canvasCarousel.list.filter(
      (carousel) => {
        return carousel.canvasId === id;
      }
    );

    await Promise.all(
      canvasCarousels.map(async (carousel) => {
        const canvasCarouselsCards = this.props.data.canvasCarouselCard.list.filter(
          (card) => {
            return card.carouselId === carousel.id;
          }
        );

        await Promise.all(
          canvasCarouselsCards.map(async (card) => {
            await this.props.deleteCanvasCarouselCard(card.id);
            return Promise.resolve(card.id);
          })
        );

        await this.props.deleteCanvasCarousel(carousel.id);
        return Promise.resolve(carousel.id);
      })
    );
  };

  searchPage = () => {
    this.setState({ section: 'search' });
    this.props.data.refetch();
  };

  render() {
    const { data, user } = this.props;
    if (!this.props.data.loading) {
      return (
        <div className="container">
          <div className="info-container">
            {this.state.processing ? (
              <Loader inline className="active" />
            ) : null}
            <span className="message-processing">{this.state.message}</span>
            <div className="message-processing">
              <ul className="error-details">
                {this.state.errorDetails.map((error) => (
                  <li>{error}</li>
                ))}
              </ul>
            </div>
          </div>
          {this.state.section === 'search' ? (
            <CanvasList
              canvases={data}
              refresh={this.refresh}
              editCanvas={this.editCanvas}
              deleteCanvas={this.deleteCanvas}
              launchCanvas={this.launchCanvas}
              newCanvas={this.newCanvas}
              getFbToken={this.props.getFbToken}
              user={user}
            />
          ) : null}
          {this.state.section === 'newCanvas' ? (
            <CanvasBuilder
              searchPage={this.searchPage}
              saveToEdit={this.saveToEdit}
              launchCanvas={this.launchCanvasWithToast}
              canvasToEdit={this.state.canvasToEdit}
              getFbToken={this.props.getFbToken}
            />
          ) : null}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

const canvasQuery = gql`
  query getAllCanvases {
    canvases: allCanvas {
      list: nodes {
        id
        name
        theme
        headline
        copy
        createdAt
        createdBy
        updatedAt
        updatedBy
        enableSwipe
      }
    }
    canvasPhoto: allCanvasPhotos {
      list: nodes {
        id
        name
        imageUrl
        targetUrl
        option
        canvasId
        order
      }
    }
    canvasVideo: allCanvasVideos {
      list: nodes {
        id
        name
        videoUrl
        option
        canvasId
        order
      }
    }
    canvasCarousel: allCanvasCarousels {
      list: nodes {
        id
        name
        option
        canvasId
        order
      }
    }
    canvasCarouselCard: allCanvasCarouselCards {
      list: nodes {
        id
        name
        imageUrl
        targetUrl
        carouselId
      }
    }
    canvasTile: allCanvasTiles {
      list: nodes {
        id
        name
        asset
        imageUrl
        canvasId
      }
    }
  }
`;

const deleteCanvas = gql`
  mutation($id: Int!) {
    deleteCanvaById(input: { id: $id }) {
      canva {
        id
        name
        theme
        headline
        copy
        createdAt
        createdBy
        updatedAt
        updatedBy
        enableSwipe
      }
    }
  }
`;

const deleteCanvasPhoto = gql`
  mutation($id: Int!) {
    deleteCanvasPhotoById(input: { id: $id }) {
      canvasPhoto {
        id
        name
        imageUrl
        option
        targetUrl
        canvasId
        order
      }
    }
  }
`;

const deleteCanvasVideo = gql`
  mutation($id: Int!) {
    deleteCanvasVideoById(input: { id: $id }) {
      canvasVideo {
        id
        name
        option
        videoUrl
        canvasId
        order
      }
    }
  }
`;

const deleteCanvasCarousel = gql`
  mutation($id: Int!) {
    deleteCanvasCarouselById(input: { id: $id }) {
      canvasCarousel {
        id
        name
        option
        canvasId
        order
      }
    }
  }
`;

const deleteCanvasCarouselCard = gql`
  mutation($id: Int!) {
    deleteCanvasCarouselCardById(input: { id: $id }) {
      canvasCarouselCard {
        id
        name
        imageUrl
        targetUrl
        carouselId
      }
    }
  }
`;

const deleteCanvasTile = gql`
  mutation($id: Int!) {
    deleteCanvasTileById(input: { id: $id }) {
      canvasTile {
        id
        name
        asset
        imageUrl
        canvasId
      }
    }
  }
`;

const withCanvasList = compose(
  graphql(canvasQuery),
  graphql(deleteCanvas, {
    props: ({ mutate }) => ({
      deleteCanvas: (id) =>
        mutate({
          variables: { id },
          updateQueries: {
            getAllCanvases: (prev) => {
              const canvasesList = prev.canvases.list.map((item) => item);
              const deleteIndex = _.findIndex(
                canvasesList,
                (item) => item.id === id
              );
              if (deleteIndex < 0) {
                return prev;
              }
              return update(prev, {
                canvases: {
                  list: {
                    $splice: [[deleteIndex, 1]]
                  }
                }
              });
            }
          }
        })
    })
  }),
  graphql(deleteCanvasPhoto, {
    props: ({ mutate }) => ({
      deleteCanvasPhoto: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(deleteCanvasVideo, {
    props: ({ mutate }) => ({
      deleteCanvasVideo: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(deleteCanvasTile, {
    props: ({ mutate }) => ({
      deleteCanvasTile: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(deleteCanvasCarousel, {
    props: ({ mutate }) => ({
      deleteCanvasCarousel: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(deleteCanvasCarouselCard, {
    props: ({ mutate }) => ({
      deleteCanvasCarouselCard: (id) =>
        mutate({
          variables: { id }
        })
    })
  })
);

const ListWithData = withCanvasList(CanvasSearch);

export default withApollo(
  connect(mapStateToProps, mapDispatchToProps)(ListWithData)
);



// WEBPACK FOOTER //
// ./src/screens/Canvas/CanvasSearch.js